import { User } from './user';

console.log('Welcome !');

let name = 'Bastien';
const user = new User(name);
